// extracted by mini-css-extract-plugin
module.exports = {"statistics":"styles_statistics__eY1zk","card":"styles_card__iZsKg","pulse":"styles_pulse__qsMZw","jump":"styles_jump__OtzsI"};